import React, {createContext, useState, useEffect, useCallback} from 'react';
import PropTypes from 'prop-types';
import {fetchCountNotification} from '../../api/request/masterFetchApi/masterFetchApi';
import makeApiCall from '../../api/makeApiCall';
import Strings from '../../constants/stringConstant';
import {getUserData} from '../../utils/appUtils';

export const NotificationContext = createContext();

export const NotificationProvider = ({children}) => {
  const [count, setCount] = useState(0);

  const fetchNotificationCount = useCallback(async () => {
    const userData = getUserData();
    if (!userData?.userId || !userData?.role) return;

    try {
      const response = await makeApiCall(
        fetchCountNotification({
          userId: userData.userId,
          roleId: userData.role,
        }),
      );

      if (response?.data?.status === Strings?.success) {
        const content = response?.data?.data?.notifcationCount ?? 0;
        setCount(content);
      }
    } catch (error) {
      console.error('Notification count fetch error:', error);
    }
  }, []);

  useEffect(() => {
    fetchNotificationCount();
  }, []);

  return (
    <NotificationContext.Provider value={{count, fetchNotificationCount}}>
      {children}
    </NotificationContext.Provider>
  );
};

NotificationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
